import request from '@/utils/request'
export default {
  namespace: 'HomePage',
  state: {
  },
  mutations: {
    save (state, payload = {}) {
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },
  actions: {
    async get_channelhome (_, payload) {
      return request({
        url: '/po/v10/config/channelhome',
        method: 'get',
        params: payload
      })
    }
    // // 执行
    // async modify_execconfig(_, data = {}){
    //   return request({
    //     url: "/api/config/inventory/modify_execconfig",
    //     method: "post",
    //     data
    //   });
    // },
  }
}



// WEBPACK FOOTER //
// ./src/pages/homePage/model.js